export default "__VITE_PUBLIC_ASSET__96131f81__"